/**
 * Makes a request to fetch the Optimizely's Datafile containing the product's experiments
 *
 */
export interface FetchOptimizelyDataFile {
  /** The remote URL where the datafile is stored */
  dataFileUrl: string
}

export const fetchOptimizelyDataFile = async ({
  dataFileUrl
}: FetchOptimizelyDataFile) => {
  const response = await fetch(dataFileUrl)

  if (!response.ok) {
    throw new Error(response.statusText)
  }

  return response.json()
}
